export const objLoaderComponentType = 'mp.objLoader';

export enum SceneMode {
  Edit = 'edit',
  Normal = 'normal',
}
